import React, { useEffect } from "react";
import { useLoginModal } from "../../context/LoginModalContext";

const RegistrationPage: React.FC = () => {
  const { openRegisterModal } = useLoginModal();

  useEffect(() => {
    openRegisterModal();
  }, [openRegisterModal]);

  // The register form is now rendered as a modal by Layout.
  // This page opens the modal for direct /register URL visits.
  return <div className="min-h-[70vh]" />;
};

export default RegistrationPage;
